<h5>Tarefas para Leilão</h5>

<div class="container">
  <div ngbAccordion #acc="ngbAccordion" activeIds="ngb-panel-0">

    <div ngbAccordionItem id="ngb-panel-0">
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Simular baixa por leilão</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-3">
                            <label for="valor">ID Leilão: </label>
                            <input type="text" id="ideLeilao" class="form-control"
                                [(ngModel)]="ideLeilao" bnMask="INTEIRO">
                        </div>
                    </div>
                    <div class="row">
                        <div class="submit col-auto">
                            <button type="button" (click)="simularBaixaLeilao()" class="btn btn-success no-margin">Simular baixa</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>


    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Simular Auditoria de Baixa por leilão</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="submit col-auto">
                            <button type="button" (click)="simularAuditoriaBaixaLeilao()" class="btn btn-success no-margin">Simular auditoria de baixa por leilão</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
            <button ngbAccordionButton class="title">Alterar Estado do Leilão</button>
        </h2>
        <div ngbAccordionCollapse>
            <div ngbAccordionBody>
                <ng-template>
                    <div class="row">
                        <div class="col-md-3">
                            <label for="valor">ID Leilão: </label>
                            <input type="text" id="ideLeilao" class="form-control"
                                   [(ngModel)]="ideLeilao" bnMask="INTEIRO">
                        </div>
                        <div class="col-md-3">
                            <label for="estados">Estado: </label>
                            <select id="estados" class="form-select" [(ngModel)]="estado">
                                <option [ngValue]=null></option>
                                <option *ngFor="let item of estados" [ngValue]="item">
                                    {{ item.nome }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="submit col-auto">
                            <button type="button" (click)="alteracaoEstadoLeilao()" class="btn btn-success no-margin">Alterar</button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
  </div>
</div>

